var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.scores),function(score,index){return _c('div',{key:index},[_c('b-badge',{attrs:{"variant":_vm.getVariant(score)}},[_vm._v(_vm._s(score))]),_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.round[score])+"x")])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }